<div class="container content">
  <app-lista-tareas></app-lista-tareas>
</div>
